module.exports = __webpack_public_path__ + "img/id-32-qrcode.748d14ac.png";